<template>
    <div class="quote">
        <template v-if="!quote.error_message">
            <div class="quote-segment">
                <div style="height: 50px;">
                    <img v-if="quote.lender_logo_url" :src="quote.lender_logo_url" :title="quote.lender_name" style="max-width: 100px; max-height: 50px; margin-right: .5rem;">
                    <strong v-else>{{ quote.lender_name }}</strong>
                </div>
                <div><strong>{{ quote.product_name }}</strong></div>
            </div>
            <div class="quote-segment quote-monthly-segment">
                <div style="">Monthly payments of</div>
                <div>{{ quote.monthly_payment | currency(2) }}</div>
            </div>
            <hr>
            <div class="quote-detail">
            <div class="quote-segment">
                <div>Term</div>
                <div>{{ quote.term }} months</div>
            </div>
            <div class="quote-segment">
                <div>APR</div>
                <div>{{ quote.representative_apr }}%</div>
            </div>
            <div class="quote-segment">
                <div>Fixed Rate</div>
                <div>{{ quote.fixed_rate }}%</div>
            </div>
            <div class="quote-segment" v-if="quote.mileage && isPcp">
                <div>Annual Mileage</div>
                <div>{{ quote.mileage }} miles</div>
            </div>
            <div class="quote-segment">
                <div>Cash Price</div>
                <div>{{ quote.cash_price | currency }}</div>
            </div>
            <div v-if="quote.total_value_added_products > 0" class="quote-segment">
                <div>Total Value Added Products</div>
                <div>{{ quote.total_value_added_products | currency }}</div>
            </div>
            <div class="quote-segment">
                <div>Deposit</div>
                <div>{{ quote.deposit | currency }}</div>
            </div>
            <div class="quote-segment">
                <div>Total amount payable</div>
                <div>{{ quote.total_amount_payable | currency }}</div>
            </div>
            <div class="quote-segment">
                <div>Total charge for credit</div>
                <div>{{ quote.total_amount_payable - quote.total_credit - quote.deposit | currency }}</div>
            </div>
            <div class="quote-segment">
                <div><span v-if="isPcp">Optional </span>Final Payment</div>
                <div>{{ quote.final_payment | currency }}</div>
            </div>
            </div>
            <secondary-pill-button
                v-if="showRemoveButton"
                colour="red"
                style="margin-top: 1rem; display: inline-block;"
                @click="$emit('remove', quote)"
            >Remove</secondary-pill-button>
            <secondary-pill-button
                v-if="showSelectButton"
                style="margin-top: 1rem; display: inline-block;"
                @click="$emit('select', quote)"
            >Select</secondary-pill-button>
        </template>
        <template v-else>
            <hero-error-message :title="quote.product_type" :detail="quote.error_message"></hero-error-message>

            <secondary-pill-button
                v-if="showRemoveButton"
                colour="red"
                style="margin-top: 1rem; display: inline-block;"
                @click="$emit('remove', quote)"
            >Remove</secondary-pill-button>
        </template>
    </div>
</template>

<script>
import Filters from '../../filters'

export default {
    filters: Filters,
    props: {
        quote: {
            type: Object,
            required: true
        },
        showRemoveButton: {
            type: Boolean,
            default: false
        },
        showSelectButton: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isPcp() {
            return this.quote.product_type === 'PCP'
        }
    }
}
</script>

<style lang="scss" scoped>
    .quote {
        text-align: left;
        border: 2px solid #eee;
        border-radius: 4px;
        padding: 1.5rem;

        .quote-segment {
            display: flex; align-items: center;
            & > div:first-child { flex: 1; }
        }

        .quote-monthly-segment {
            & > div:first-child { font-size: 1.1rem; }
            & > div:last-child { font-size: 1.8rem; font-weight: bold; }
        }

        .quote-detail {
            font-size: 1rem;
            color: #999;
        }
    }
</style>